<template>
  <div class="home-charts" v-loading="isLoading">
    <ListHeader :title="'舆情类别分布'" :isShowTab="false"></ListHeader>
    <div class="distribute-charts">
      <HomeNewsDistributeChart :data="chartsData" @change="mouseoverData" v-if="chartsData"></HomeNewsDistributeChart>
      <div class="no-data-container" v-if="!chartsData && !isLoading">
        <no-data></no-data>
      </div>
    </div>
    <div class="card-data" v-show="value">
        <div id="value">{{value}}</div>
        <div class="name">{{name}}</div>
        <div id="percent">{{percent}}%</div>
        <div class="word">占比</div>
    </div>
    <div class="card-data" v-if="!value && chartsData">
        <div :style="{color: `${chartsData.series[0].itemStyle.color.toString()}`}" id="value">{{chartsData.series[0].value}}</div>
        <div class="name">{{chartsData.series[0].name}}</div>
        <div :style="{color: `${chartsData.series[0].itemStyle.color.toString()}`}" id="percent">{{chartsData.series[0].percent}}</div>
        <div class="word">占比</div>
    </div>
    <div class="legend" v-if="chartsData">
      <div :style="{color: `${item.itemStyle.color.toString()}`}" :class="{bg:index%2 === 0}" class="row legend-item" v-for="(item, index) in chartsData.series" :key="index">
          <div class="legend-name">{{item.name}}</div>
          <div>{{item.percent}}</div>
      </div>
    </div>
    <div class="legend-value" v-if="chartsData">
      <div :style="{color: `${item.itemStyle.color.toString()}`}" :class="{bg:index%2 === 0}" class="row legend-value-item" v-for="(item, index) in chartsData.series" :key="index">
          <div></div>
          <div>{{item.value}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/common/ListHeader';
import NoData from '@/components/common/NoData';
import HomeNewsDistributeChart from '@/components/news-monitor/HomeNewsDistributeChart';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      isLoading: false,
      username: '',
      oEmg: {},
      oEmg1: {},
      value: 0,
      name: '',
      percent: 0,
      color: '',
      series: [],
      chartsData: null,
      timer: null
    };
  },
  methods: {
    mouseoverData(res) {
      this.value = res.value;
      this.name = res.name;
      this.percent = res.percent;
      if (res.color === '#59595a') {
        this.oEmg.style.color = '#ccc';
        this.oEmg1.style.color = '#ccc';
      } else {
        this.oEmg.style.color = res.color;
        this.oEmg1.style.color = res.color;
      }
    },
    getHomeDistributeRisk() {
      this.isLoading = true;
      this.getHomeRisk();
    },
    getHomeRisk() {
      QuestionQuery.homeRisk(this.username).then(res => {
        this.isLoading = false;
        let itemStyle = null;
        const fields = res.categoryData;
        const series = res.categoryDetailsData.map(item => {         
          if (item.type === 'negative') {
            itemStyle = {
              color: ['#50b191'],
              opacity: 0.8
            };
          } else if (item.type === 'positive') {
            itemStyle = {
              color: ['#d84751'],
              opacity: 0.8
            };
          } else if (item.type === 'neutral') {
            itemStyle = {
              color: ['#666'],
              opacity: 0.8
            };
          }
          return {
            name: item.name,
            value: item.value,
            percent: item.percent,
            itemStyle
          };
        });
        this.chartsData = {
          fields,
          series
        };
      });
    }
  },
  components: {
    ListHeader,
    HomeNewsDistributeChart,
    NoData
  },
  mounted() {
    this.oEmg = document.getElementById('value');
    this.oEmg1 = document.getElementById('percent');
    this.username = authService.getLoggedUserName();
    this.getHomeDistributeRisk();
    this.timer = window.setInterval(() => {
      this.getHomeRisk();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>

  .distribute-charts {
    position: relative;
    width: 100%;
    height: 550px;
    background-color: #3e3c42;
    .no-data-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .no-data {
        font-size: 18px;
      }
    }
  }
  .home-charts {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    .legend {
      position: absolute;
      bottom: 47px;
      left: 50%;
      transform: translateX(-50%);
      width: 260px;
      height: 200px;
      font-size: 14px;
      pointer-events: none;
      background-color: #3e3c42;
      .bg {
        background-color: #444247;
      }
      .legend-item {
        padding: 0 12px;
        justify-content: space-between;
        height: 24px;
        line-height: 24px;
        .legend-name {
          width: 95px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .legend-value {
      position: absolute;
      bottom: 47px;
      left: 52%;
      transform: translateX(-50%);
      width: 45px;
      height: 200px;
      font-size: 14px;
      pointer-events: none;
      background-color: #3e3c42;
      z-index: 1;
      .bg {
        background-color: #444247;
      }
      .legend-value-item {
        justify-content: space-between;
        height: 24px;
        line-height: 24px;
      }
    }
  }
  .card-data {
    position: absolute;
    top: 42%;
    left: 50%;
    transform: translate(-50%, -98%);
    width: 107px;
    height: 107px;
    padding-top: 8px;
    border-radius: 50%;
    #value {
      font-size: 20px;
      text-align: center;
    }
    .name {
      color: #999999;
      font-size: 12px;
      text-align: center;
    }
    #percent {
      font-size: 20px;
      text-align: center;
    }
    .word {
      color: #999999;
      font-size: 12px;
      text-align: center;
    }
  }
</style>

